// extracted by mini-css-extract-plugin
module.exports = {"createOrganization":"FormDialog_createOrganization__fm4Dz","content":"FormDialog_content__3_ZJD","footer":"FormDialog_footer__3hnx_"};